import { RouteConfig } from "vue-router";

export const RExpertTemplateActivityLog: RouteConfig = {
  path: "activity",
  component: () =>
    import(
      /* webpackChunkName: "expert-template-activity-log" */
      "./VTemplateActivityLog.vue"
    ),
  meta: {
    label: "Activity Log",
    tabName: "activity",
  },
};
